import { SharedSettings } from './../../../sharedTypes/admin';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';

import { GlobalService } from './global.service';

@Injectable()
export class StateService {
    sharedSettings = new BehaviorSubject<SharedSettings>(new SharedSettings({}));
    sharedSub: Subscription = new Subscription();

    subsStarted = false;
    searchKey = new BehaviorSubject<{ searchkey: string; validUntil: number }>({ searchkey: '', validUntil: 0 });

    constructor(private firebaseService: FirebaseService, private glo: GlobalService) {}

    tabId: any;

    async getAlgoliaKey() {
        const key = await this.firebaseService.getAlgoliaKey();
        console.log('getAlgoliaKey', key);
        this.searchKey.next(key);
    }
    async startSubs() {
        this.subsStarted = true;
        if (this.sharedSub) {
            this.sharedSub.unsubscribe();
        }
        this.sharedSub = this.firebaseService.getSharedSettings().subscribe((arg) => {
            console.log('sharedSettings', arg);
            if (arg) {
                this.sharedSettings.next(arg);
            }
        });
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    stopAllSubs() {
        if (this.sharedSub) {
            this.sharedSub.unsubscribe();
        }
        this.firebaseService.myCalls = [];
        this.firebaseService.missedCalls = [];
        this.searchKey.next({ searchkey: '', validUntil: 0 });
        return this.delay(500);
    }
}
